import { Link } from 'react-router-dom';
import '../styles/Home.css';

import item from '../assets/oot-icon.svg'
import game from '../assets/nintendo-switch.svg'
import character from '../assets/character.png'
import sword from '../assets/sword.png'
import sound from '../assets/sound.png'

import { useTranslation } from 'react-i18next';

function Home() {
    const { t } = useTranslation();

    return (
        <div className='home'>
            <h1>{t('home.title')}</h1>
            <ul>
                <li><span><img src={item} alt={t('home.item')} title={t('home.item')} /> </span><Link className="home-item" to="/item">{t('home.item')}</Link></li>
                <li><span><img src={game} alt={t('home.game')} title={t('home.game')} /> </span><Link className="home-item"to="/game">{t('home.game')}</Link></li>
                <li><span><img src={character} alt={t('home.character')} title={t('home.character')} /> </span><Link className="home-item"to="/character">{t('home.character')}</Link></li>
                <li><span><img src={sword} alt={t('home.sword')} title={t('home.sword')} /> </span><Link className="home-item"to="/sword">{t('home.sword')}</Link></li>
                <li className='soon'><span><img src={sound} alt={t('home.sound')} title={t('home.sound')} /> </span><Link className="home-item"to="/">{t('home.sound')}</Link></li>
            </ul>
        </div>
        )
}

export default Home
